module.exports = __webpack_public_path__ + "static/media/XEND-BNB.258f2ebc.svg";